import { ModalProps } from '@billy/design-system'

import { AttachmentType } from '@features/attachments/enums/attachmentType'
import { useFetchAttachment } from '@features/attachments/hooks/useFetchAttachment'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import type { EInvoiceLifecycleTrackingSource } from '@views/receipts/enums/tracking'

import { FrenchMarketEInvoiceRejectionModal } from './FrenchMarketEInvoiceRejectionModal'
import { OtherMarketEInvoiceRejectionModal } from './OtherMarketEinvoiceRejectionModal'

interface ReceiptRejectionModalProps extends ModalProps {
  attachmentId?: string
  onSuccess?: () => void
  trackingSource: EInvoiceLifecycleTrackingSource
}

export const ReceiptRejectionModal = ({
  attachmentId,
  onSuccess,
  trackingSource,
  ...modalProps
}: ReceiptRejectionModalProps) => {
  const { attachment } = useFetchAttachment(attachmentId)
  const { organization } = useUserOrganization()
  const isFrenchMarketEInvoice = attachment?.type === AttachmentType.EDocument && organization?.countryId === 'FR'

  return isFrenchMarketEInvoice ? (
    <FrenchMarketEInvoiceRejectionModal
      attachmentId={attachmentId}
      onSuccess={onSuccess}
      trackingSource={trackingSource}
      {...modalProps}
    />
  ) : (
    <OtherMarketEInvoiceRejectionModal attachmentId={attachmentId} onSuccess={onSuccess} {...modalProps} />
  )
}
